module.exports = __webpack_public_path__ + "img/11.3f94ee08.png";